module.exports = __webpack_public_path__ + "img/debao.0408a13c.png";